/* eslint-disable no-nested-ternary */
import React from 'react';
import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';
import { Table } from 'reactstrap';

import { LoaderLista } from '~/components/Loaders';
import { symbolPriceFormatter } from '~/helpers/price';

// import { FiltroFilial } from '~/components/Filtros/FiltroFilial';
import { TrStyled } from './styles';

export function CardFilial(props) {
	const { isMobile } = props;
	const {
		dataFiliais,
		totalFilial,
		loadingResumo,
		pagina,
		setPagina
	} = props;

	function handlerPagination(page) {
		setPagina(page);
		// getResumo(user.dados.documento, 10, page, filtroOrder, filtroPesquisa).then(res => {
		// 	setTotalItemsResumo(res.data.total_registros);
		// 	setDataResumo(res.data);
		// });
	}

	// useEffect(() => {
	// 	if (filtroOrder || filtroPesquisa === '' || filtroPesquisa.length > 0) {
	// 		getResumo(user.dados.documento, 10, pagina, filtroOrder, filtroPesquisa)
	// 	}
	// }, [filtroOrder, filtroPesquisa]);

	return (
		<>
			{/* <FiltroFilial
				user={user}
				setFiltroPesquisa={setFiltroPesquisa}
				setFiltroStatus={setFiltroOrder}
				filtroStatus={filtroOrder}
				setPagina={setPagina}
			/> */}
			<LoaderLista loading={!loadingResumo} lista={dataFiliais}>
				<Table id="test-table-xls-button" responsive>
					<thead>
						<TrStyled>
							{/* <th>Atualização</th> */}
							<th style={{ textAlign: 'left' }}>Filiais</th>
							<th>Crédito</th>
						</TrStyled>
					</thead>
					<tbody>
						{ dataFiliais && dataFiliais.length > 0 && dataFiliais.map((item) => {
							return (
								<tr style={{ textAlign: 'center' }}>
									{/* <td>
										{moment(item.ultima_consulta).format(
											'DD/MM/YYYY'
										)}
									</td> */}
									<td style={{ textAlign: 'left' }}>{item.nome_filial}</td>
									<td>{symbolPriceFormatter(item.saldo_filial)}</td>
								</tr>
							);
						})}
					</tbody>
				</Table>

				<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
					<Pagination
						activePage={pagina}
						totalItemsCount={totalFilial}
						onChange={(page) => handlerPagination(page)}
						prevPageText={<ChevronLeftOutlined />}
						nextPageText={<ChevronRightOutlined />}
						firstPageText={<FirstPageOutlined />}
						lastPageText={<LastPageOutlined />}
					/>
				</div>
			</LoaderLista>
		</>
	);
}
